import * as React from 'react'
import { PageLoader } from '../common/PageLoader'
import { Gallery, Item } from 'react-photoswipe-gallery'
import 'photoswipe/dist/photoswipe.css'
import {
  withOneplaceLibraryContext,
  IOneplaceLibraryContextProp
} from '../OneplaceLibraryProvider'
import { TEMP_IMAGE_PREFIX } from '../../data_sources/imagestorage/imageStorage'

export interface IHelpImagesProps extends IOneplaceLibraryContextProp {
  imageUrls: Array<{ url: string }>
  accessToken?: string
  isOpen: boolean
  onClose: () => void
}

export interface IHelpImagesState {
  loadState: 'loading' | 'loaded'
  localImageUrls: string[]
  photoIndex: number
  imageDimensions: Array<{ width: number; height: number }>
}

export const HelpImages = withOneplaceLibraryContext(
  class extends React.Component<IHelpImagesProps, IHelpImagesState> {
    static displayName = 'HelpImages'
    private openFunctions: Array<((e: React.MouseEvent) => void) | null> = []

    constructor(props: any) {
      super(props)
      this.state = {
        loadState: 'loading',
        localImageUrls: [],
        photoIndex: 0,
        imageDimensions: []
      }
      void this.loadData()
    }

    async loadImageDimensions(
      url: string
    ): Promise<{ width: number; height: number }> {
      return new Promise((resolve) => {
        const img = new Image()
        img.onload = () => {
          resolve({ width: img.naturalWidth, height: img.naturalHeight })
        }
        img.onerror = () => {
          // Return default dimensions if image fails to load
          resolve({ width: 1600, height: 1200 })
        }
        img.src = url
      })
    }
    async loadData() {
      const imageDataPromises = this.props.imageUrls.map((helpLink) => {
        if (this.props.accessToken) {
          return this.props.ctx.client.getLocalAssetUrl('helpimg', helpLink.url)
        } else {
          return this.props.ctx.client.getLocalAssetUrl(
            'helpimg',
            helpLink.url,
            this.props.accessToken
          )
        }
      })

      const templocalImageUrls = await Promise.all(imageDataPromises)
      const localImageUrls: string[] = []
      templocalImageUrls.forEach((field: string) => {
        console.log('before' + field)
        if (field.includes(TEMP_IMAGE_PREFIX)) {
          field = field.substr(TEMP_IMAGE_PREFIX.length)
        }
        localImageUrls.push(field)
      })
      console.log(localImageUrls)

      // Load image dimensions
      const imageDimensions = await Promise.all(
        localImageUrls.map((url) => this.loadImageDimensions(url))
      )

      this.setState({
        loadState: 'loaded',
        localImageUrls,
        imageDimensions
      })
    }
    componentDidUpdate(
      prevProps: IHelpImagesProps,
      prevState: IHelpImagesState
    ) {
      // Open gallery when either isOpen becomes true or when images finish loading
      const shouldOpen =
        (this.props.isOpen && !prevProps.isOpen) ||
        (this.props.isOpen &&
          this.state.loadState === 'loaded' &&
          prevState.loadState === 'loading')

      if (
        shouldOpen &&
        this.state.loadState === 'loaded' &&
        this.state.localImageUrls.length > 0
      ) {
        // Open the gallery at the first image
        setTimeout(() => {
          if (this.openFunctions[0]) {
            this.openFunctions[0]({} as React.MouseEvent)
          }
        }, 100)
      }
    }

    render() {
      console.log(`#### render photoswipe with obecjt fit contain`)
      return (
        <div>
          {this.state.loadState != 'loaded' && (
            <div style={{ minWidth: 175 }}>
              <PageLoader loading={true} />
            </div>
          )}
          {this.state.loadState == 'loaded' &&
            this.state.localImageUrls.length > 0 && (
              <Gallery
                onOpen={(photoSwipe) => {
                  photoSwipe.on('close', () => {
                    this.props.onClose()
                  })
                }}
                options={{
                  zoom: false,
                  close: true,
                  arrowKeys: true,
                  index: 0
                }}
              >
                <div style={{ display: 'none' }}>
                  {this.state.localImageUrls.map((url, index) => (
                    <Item
                      key={index}
                      original={url}
                      width={this.state.imageDimensions[index]?.width || 1600}
                      height={this.state.imageDimensions[index]?.height || 1200}
                    >
                      {({ ref, open }) => {
                        // Store the open function
                        this.openFunctions[index] = open
                        return <div ref={ref} />
                      }}
                    </Item>
                  ))}
                </div>
              </Gallery>
            )}
        </div>
      )
    }
  }
)
export default HelpImages
